module.exports = __webpack_public_path__ + "static/media/RoomPi2.81cc2349.JPG";